import { render } from "./g-menu-item.vue?vue&type=template&id=f62d3446&scoped=true"
import script from "./g-menu-item.vue?vue&type=script&lang=js"
export * from "./g-menu-item.vue?vue&type=script&lang=js"

import "./g-menu-item.vue?vue&type=style&index=0&id=f62d3446&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f62d3446"]])

export default __exports__